import React from 'react';

import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import { FILE_TYPES_TO_MIME_TYPES, fileTypes } from 'components/helpers/files';

export default function ValidationErrorMessage({
  acceptedMimeTypes,
  file,
  maxSize,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'uploader.components.ValidationErrorMessage',
  });

  const { name, size, type: mimeType } = file;

  const errors = [];

  if (size > maxSize) {
    errors.push(i18nT('errors.maxSize', { maxSizeInMB: maxSize / 1000000 }));
  }

  if (!acceptedMimeTypes.includes(mimeType)) {
    errors.push(
      i18nT(
        `errors.type.${fileTypes({ mimeTypes: acceptedMimeTypes })
          .sort((a, b) => a.localeCompare(b))
          .join(',')}`,
      ),
    );
  }

  return (
    <>
      <Trans
        i18nKey='uploader.components.ValidationErrorMessage.description'
        ns='components'
        values={{ filename: name }}
      />
      <ul>
        {errors.map((error, index) => (
          <li key={index}>
            <span>{error}</span>
          </li>
        ))}
      </ul>
    </>
  );
}

ValidationErrorMessage.propTypes = {
  acceptedMimeTypes: PropTypes.arrayOf(
    PropTypes.oneOf(Object.values(FILE_TYPES_TO_MIME_TYPES)),
  ),
  file: PropTypes.shape({
    name: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  maxSize: PropTypes.number,
};
